import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileStickyBar from "@/components/MobileStickyBar";

import Home from "@/pages/Home";
import WhatWeDo from "@/pages/WhatWeDo";
import ServiceDetail from "@/pages/ServiceDetail";
import IndustryReach from "@/pages/IndustryReach";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import NotFound from "@/pages/NotFound";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PositioningReview from "@/pages/PositioningReview";
import FAQ from "@/pages/FAQ";
import Industries from "@/pages/Industries";
import OurApproach from "@/pages/OurApproach";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="App grain min-h-screen">
      {!isAdmin && <Navbar />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/industry-reach" element={<IndustryReach />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:slug" element={<ClientDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/positioning-review" element={<PositioningReview />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/our-approach" element={<OurApproach />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <MobileStickyBar />}
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#0f172a",
            border: "1px solid #e2e8f0",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
